import styled from 'react-emotion'

const series = ['#03527D', '#7d0352', '#037d2e', '#7d2e03']

const Legend = styled('div')`
	align-items: center;
	display: flex;
	justify-content: center;
	margin: 2rem 0;
	&>div {
		align-items: center;
		display: flex;
		justify-content: center;
		padding: 0 1rem;
		position: relative;
		&:before {
			content: "";
			display: block;
			height: 1rem;
			margin-right: 0.5rem;
			width: 1rem;
		}
	}
	&>div:nth-child(1):before {
		background-color: ${series[0]};
	}
	&>div:nth-child(2):before {
		background-color: ${series[1]};
	}
	&>div:nth-child(3):before {
		background-color: ${series[2]};
	}
	&>div:nth-child(4):before {
		background-color: ${series[3]};
	}
`

export default Legend